import { render, staticRenderFns } from "./selectList.vue?vue&type=template&id=aa528378&scoped=true&"
import script from "./selectList.vue?vue&type=script&lang=js&"
export * from "./selectList.vue?vue&type=script&lang=js&"
import style0 from "./selectList.vue?vue&type=style&index=0&id=aa528378&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa528378",
  null
  
)

export default component.exports